import { INNER_SPOKES, ORBIT_NODES, OUTER_TICKS } from './celestialWheelData'

function NodeIcon({ node }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={`w-5 h-5 ${node.textClass} group-hover:text-goldPrimary transition-colors`}
    >
      {node.circle && <circle cx={node.circle.cx} cy={node.circle.cy} r={node.circle.r} />}
      {node.paths.map((d, i) => (
        <path key={i} d={d} />
      ))}
    </svg>
  )
}

export default function CelestialWheel() {
  return (
    <div className="absolute lg:relative inset-0 lg:inset-auto lg:col-span-6 flex flex-col items-center justify-center px-2 sm:px-4 z-0 lg:z-10 opacity-20 sm:opacity-30 lg:opacity-100 pointer-events-none lg:pointer-events-auto overflow-hidden lg:overflow-visible">
      <div className="absolute w-56 sm:w-72 h-56 sm:h-72 rounded-full bg-goldPrimary/10 filter blur-3xl pointer-events-none" />

      <div className="celestial-wheel w-[min(460px,85vw)] sm:w-[min(460px,40vw)] lg:w-[min(460px,40vw)] select-none">
        <div className="relative aspect-square w-full" aria-hidden="true">
          <div className="absolute inset-[-9%] rounded-full bg-[radial-gradient(circle,transparent_56%,rgba(232,119,15,0.12)_72%,transparent_82%)] pointer-events-none" />

          <div className="absolute inset-[-9%] animate-spin-110-reverse freeze-on-hover pointer-events-none">
            <svg viewBox="0 0 400 400" className="w-full h-full" fill="none">
              <circle cx="200" cy="200" r="188" stroke="#E6C878" strokeOpacity="0.22" strokeWidth="1" strokeDasharray="1 13" />
              {OUTER_TICKS.map((deg) => (
                <line
                  key={deg}
                  x1="200"
                  y1="8"
                  x2="200"
                  y2="24"
                  stroke="#C99A2E"
                  strokeOpacity="0.25"
                  strokeWidth="1.5"
                  transform={`rotate(${deg} 200 200)`}
                />
              ))}
            </svg>
          </div>

          <div className="absolute inset-[16%] rounded-full bg-[radial-gradient(circle,rgba(232,119,15,0.32),transparent_70%)] blur-2xl pointer-events-none" />

          <div className="absolute inset-0 animate-spin-140-normal freeze-on-hover pointer-events-none">
            <svg viewBox="0 0 400 400" className="w-full h-full" fill="none">
              <circle cx="200" cy="200" r="196" stroke="#E6C878" strokeOpacity="0.5" strokeWidth="1" />
              <circle cx="200" cy="200" r="150" stroke="#C99A2E" strokeOpacity="0.32" strokeWidth="1" strokeDasharray="2 9" />
              <circle cx="200" cy="200" r="92" stroke="#E8770F" strokeOpacity="0.4" strokeWidth="1" />
              {INNER_SPOKES.map((deg) => (
                <line
                  key={deg}
                  x1="200"
                  y1="200"
                  x2="200"
                  y2="58"
                  stroke="#C99A2E"
                  strokeOpacity="0.18"
                  strokeWidth="1"
                  transform={`rotate(${deg} 200 200)`}
                />
              ))}
            </svg>
          </div>

          <div className="absolute inset-[7%] animate-spin-70-normal freeze-on-hover z-20">
            {ORBIT_NODES.map((node) => (
              <div className="absolute inset-0" style={{ transform: `rotate(${node.angle}deg)` }} key={node.label}>
                <div className="absolute left-1/2 top-0 -translate-x-1/2 -translate-y-1/2">
                  <div className="animate-spin-70-reverse freeze-on-hover">
                    <div
                      className="astro-node flex flex-col items-center gap-1.5 cursor-pointer group"
                      style={{ transform: `rotate(${-node.angle}deg)` }}
                      data-title={node.title}
                      data-desc={node.desc}
                    >
                      <div
                        className={`w-11 h-11 md:w-12 md:h-12 rounded-full grid place-items-center bg-[#1A0E06] shadow-[0_6px_20px_-8px_rgba(0,0,0,0.8)] border ${node.borderClass} group-hover:border-[#F59E0B] group-hover:ring-4 group-hover:ring-goldPrimary/30 transition-all duration-300`}
                      >
                        <NodeIcon node={node} />
                      </div>
                      <span className="font-royal text-[8px] md:text-[9px] uppercase tracking-[0.1em] text-[#E6C878] group-hover:text-goldPrimary whitespace-nowrap leading-none transition-colors">
                        {node.label}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="absolute inset-0 grid place-items-center z-10 pointer-events-none">
            <div className="relative w-[28%] aspect-square rounded-full grid place-items-center bg-[radial-gradient(circle,#2A1408,#140A05)] border border-[#E6C878]/50 shadow-[0_0_44px_-10px_rgba(232,119,15,0.7)] animate-core-breathe">
              <span
                className="text-2xl md:text-3xl text-[#F0D9A0]"
                style={{ textShadow: 'rgba(232, 119, 15, 0.7) 0px 0px 18px' }}
              >
                ॐ
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
